(ns manage.content-variant-page.entities.tagging.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [manage.content-variant-page.entities.tagging-tracker-ocp.macro-input :refer [macro-input]]
            [manage.content-variant-page.entities.tagging.db :as tagging]
            [mate.core :as mc]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui tagging-url-input []
  ($ Stack {:spacing 1}
     ($ form-field
        {:label "Tagging string"}
        ($ :div
           ($ :span " (It’s also possible to import parameter values by pasting a tagging url here)")
           ($ Stack {:direction "row"
                     :alignItems "center"
                     :gap 1
                     :sx #js {:p 1.5}}
              ($ Icon "lock_outline")
              ($ Typography {:fontWeight 600} "www.example_url.com/?")
              (r/as-element
               [macro-input {:sx #js {:flexGrow 1}
                             :value (use-subscribe [::tagging/tagging-url])
                             :allow-query-params? true
                             :allow-macros? true
                             :on-change (fn [value]
                                          (rf/dispatch [::tagging/set-tagging-url value]))}]))))))

(def predefined-attribute-values
  ["utm_source"
   "utm_medium"
   "utm_campaign"
   "utm_term"
   "utm_content"])

(defui query-param-list-item [{:keys [index attribute-text value-text]}]
  ($ Stack {:direction "row" :spacing 2 :alignItems "start"}
     ($ form-field
        {:sx #js {:flexBasis "34%"}
         :label "Parameter"
         :data-testid "query-param-attribute-input"}
        (r/as-element
         [dropdown
          {:free-solo true
           :placeholder "Type a parameter"
           :options (mapv (fn [predefined-attribute-value]
                            {:label predefined-attribute-value
                             :value predefined-attribute-value}) predefined-attribute-values)
           :input-value (or attribute-text "")
           :value-fn (fn [value]
                       (if (string? value)
                         value
                         (:value value)))
           :value-renderer (fn [value]
                             (if (string? value)
                               value
                               (:label (js->clj value :keywordize-keys true))))
           :on-input-change (fn [^js _event ^js new-input-value]
                              (rf/dispatch [::tagging/set-tagging-attribute index new-input-value]))
           :on-change (fn [value]
                        (rf/dispatch [::tagging/set-tagging-attribute index value]))}]))
     ($ form-field
        {:sx #js {:flexBasis "66%"}
         :label ($ Stack
                   {:direction "row"
                    :alignItems "center"
                    :spacing 0.5}
                   ($ Typography
                      {:component "label"
                       :fontWeight "600"
                       :data-component :form-field__label}
                      "Value")
                   ($ Tooltip
                      {:placement "top"
                       :title "Unlock the power of dynamic macros by typing \"${xxx}\""}
                      ($ Icon {:fontSize "small"} "info")))
         :data-testid "query-param-value-input"}
        (r/as-element
         [macro-input {:sx #js {:flexGrow 1}
                       :value (or value-text "")
                       :allow-macros? true
                       :on-change (fn [value]
                                    (rf/dispatch [::tagging/set-tagging-value index value]))}]))
     ($ IconButton
        {:sx #js {:alignSelf "flex-end"}
         :onClick (fn [^js _event]
                    (rf/dispatch [::tagging/delete-tagging-param index]))
         :data-testid "delete-query-param"}
        ($ Icon "delete"))))

(defui query-param-list []
  ($ Stack {:spacing 2}
     (for [[index [attribute value]] (mc/seq-indexed (use-subscribe [::tagging/tagging-params]))]
       ($ query-param-list-item {:key index :index index :attribute-text attribute :value-text value}))
     ($ Button {:startIcon ($ Icon "add")
                :variant "text"
                :onClick (fn [^js _event]
                           (rf/dispatch [::tagging/add-tagging-param]))
                :sx #js {:alignSelf "flex-start"}}
        "Add new parameter")))

(defui tab-panel []
  ($ Stack {:spacing 2}
     ($ tagging-url-input)
     ($ query-param-list)))
